// import { API_BASE_URL, IS_DEV, IS_TEST } from '@inn/const';
import { useMessage } from '@inn/components';
import { createXhr, getBaseConfigByOrigin, resolveEnvironmentVariables } from '@inn/utils';
import { pick } from 'radash';
import { useTokenStore } from '@/storage/tokens';
import ProgressBar from '@/components/xom-progress-bar';

const { IS_DEV, IS_TEST, variable: API_BASE_URL } = resolveEnvironmentVariables('API_BASE');

if (IS_DEV || IS_TEST) {
  window.console.info(
    '%c%s%c%s',
    'background: #35495E; color: white; padding: 1px 6px;',
    'Api address at:',
    'background: #41B883; color: white; padding: 1px 6px;',
    `http:${getBaseConfigByOrigin(API_BASE_URL)}/doc.html`,
  );
}

export const xhr = createXhr({
  baseURL: getBaseConfigByOrigin(API_BASE_URL),
  processor: ProgressBar,
  getTokens: () => pick(useTokenStore(), ['sysAccessToken', 'sysRefreshToken', 'autoRefreshToken']),
  refreshToken: () => useTokenStore().flush(),
  tooltip: (msg) => useMessage('error', { content: msg }),
});
